import { FormatLetterCaseUpperIcon } from './FormatLetterCaseUpperIcon';

/**
 * author: Austin Andrews
 * id 0C748102-1ABB-4762-A407-B64C960618D7
 * name format-letter-case-upper
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/format-letter-case-upper.svg
 * tags
 * - Text / Content / Format 
 */
export const FormatUppercaseIcon = FormatLetterCaseUpperIcon;
export default FormatUppercaseIcon